// @ts-nocheck
import GenericRenderContainerSection from './GenericRenderContainerSection';
import styled from 'styled-components';
import colors from '../../../styles/colors';
import RenderSingleMatchCard from './SingleMatchCardPrimeArchivioFunctions/RenderSingleMatchCard';
import RenderGenericMatchCard from './SingleMatchCardPrimeArchivioFunctions/RenderGenericMatchCard';
import { TopDecorColor } from '../../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';

const ContainerSingleYear = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
    background: linear-gradient(160deg, rgba(90, 15, 15, 0.9) 0%, rgba(25, 25, 25, 0.98) 100%);
    border: 2px solid rgba(255, 255, 255, 0.25);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 20px 0 10px 0;
    margin: 10px 0;

    & h1, h2, h3, h4, h5, h6 {
        font-size: 10px;
        font-weight: 500;
        color: white;
    }

    & h2.year-title {
        font-size: 16px;
        font-weight: 800;
        color: white;
        margin: 10px 0;
        padding: 0;
    }
`;

const ContainerListFights = styled.div`
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: center;
    width: 95%;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px 0;
`;

function ArchivioRender({ allFights, wrestlerId }) {

    // Da AllFights mi formo una variabile che contiene tutti i fights raggruppati per anno(contenuto dentro ppv.date.split('-')[2])
    const fightsByYear = allFights?.reduce((acc, fight) => {
        if (fight.ppv?.date) {
            const year = fight.ppv.date.split('-')[2]; // Estrae l'anno dalla data
            if (!acc[year]) {
                acc[year] = [];
            }
            acc[year].push(fight);
        }
        return acc;
    }, {}) || {};

    // Ordina gli anni dal più recente al più vecchio
    const sortedYears = Object.keys(fightsByYear).sort((a, b) => b - a);

    return (
        <GenericRenderContainerSection
         className='archivio-render'
         width="100%"
         padding="10px"
        >
            <p className='info-section info-archivio'>
                Tutti i match della sua carriera. Cliccando sul match, si viene indirizzati al PPV.
            </p>

            {sortedYears.map(year => (
                <ContainerSingleYear key={year} className='container-single-year'>
                    <TopDecorColor />

                    <h2 className='year-title'>{year}</h2>

                    <ContainerListFights className='container-list-fights'>

                        {fightsByYear[year].map((fight, index) => (
                            fight.type_match.type === "single" ? (
                                    RenderSingleMatchCard(fight, index, wrestlerId)
                                ) : (
                                    RenderGenericMatchCard(fight, index, wrestlerId)
                                )
                            )
                        )}
                    </ContainerListFights>
                </ContainerSingleYear>
            ))}

        </GenericRenderContainerSection>
    )
}

export default ArchivioRender;